import { Observable, OperatorFunction, pipe } from 'rxjs';
import { first, switchMap } from 'rxjs/operators';
import { filterNullUndefined } from './filter-null-undefined';

export function mapToLatestFrom<T>(
  source: Observable<T | undefined | null>
): OperatorFunction<unknown, T> {
  return pipe(switchMap(() => source.pipe(filterNullUndefined(), first())));
}
